import { Icon } from "@resource/atlas/icon/Icon";
import { getAtssyncInfo } from "client/utils/atssync";
import { AtssyncAccountType } from "generated/graphql-codegen/graphql";
import _ from "lodash";

interface AtsDepartment {
  id: string;
  name: string;
}

interface AtsOffice {
  id: string;
  name: string;
}

interface AtsJob {
  id: string;
  name: string;
  requisitionId: string | null;
  atsDepartments: AtsDepartment[];
  atsOffices: AtsOffice[];
  account: {
    type: AtssyncAccountType;
  };
}

interface Job {
  id: string;
  name: string;
  atsJob: AtsJob | null;
}

interface JobNameCellProps {
  job: Job;
  value: string;
}

function JobNameCell({ job, value }: JobNameCellProps) {
  const reqId = job?.atsJob?.requisitionId;
  const department = _.first(job?.atsJob?.atsDepartments)?.name;
  const office = _.first(job?.atsJob?.atsOffices)?.name;
  const atssyncType = job.atsJob?.account.type;

  return (
    <div className="flex items-center space-x-2">
      {atssyncType ? <Icon content={getAtssyncInfo(atssyncType).icon} /> : null}
      <div className="flex flex-col overflow-hidden text-body-md">
        <div className="flex overflow-hidden items-center">
          <div className="truncate">{value}</div>
          {reqId && (
            <div className="text-subtle flex-shrink-0">&nbsp;({reqId})</div>
          )}
          {/* {job?.isDemo && <Badge className="ml-2">Example</Badge>} */}
        </div>
        <div className="text-subtle">
          {department}
          {department && office && (
            <span className="font-bold">&nbsp;·&nbsp;</span>
          )}
          {office}
        </div>
      </div>
    </div>
  );
}

export default JobNameCell;
